export default [
    '#3B5194',
    '#A80039',
    '#E79B00',
    '#E0FEFE',
    '#D3EEFF',
];
